import React from "react";
import { checkString, getName } from "../../../CommonMethhods/CommonMethods";
import SmallLoader from "../../../Components/Common/smallLoader";


function PartnerApplicationStatusComp(props) {
  let partnerDetails = props.partnerDetails;


  const loader = props.loader;
  function addressArray(array) {
    let a = "";
    array.forEach((item) => {
      if (item.length > 0) {
        if (item != " " && item != "NA") a = a + item + ",";
      }
    });
    return a.length > 0 ? a : "NA";
  }

  const Address1 =
    partnerDetails === undefined || null
      ? "NA"
      : checkString(partnerDetails?.address);

  const Address2 =
    partnerDetails === undefined || null
      ? "NA"
      : checkString(partnerDetails?.address2);

  const State =
    partnerDetails === undefined || null
      ? "NA"
      : checkString(partnerDetails?.state);

  const City =
    partnerDetails === undefined || null
      ? "NA"
      : checkString(partnerDetails?.city);

  const Zip =
    partnerDetails === undefined || null
      ? "NA"
      : checkString(partnerDetails?.pincode);

  const GetFName =
    partnerDetails === undefined || null
      ? " "
      : partnerDetails?.nameOnPan === undefined || null
        ? " "
        : partnerDetails?.nameOnPan;



  return (
    <>
      <div className="user-profile card-box  partner-application">
        <div>
          <div className="user-profile__top">
            <div className="profile__details d-flex">
              <div className="profile__img">
                {partnerDetails === undefined || null ? (
                  <h2 className="profile-img-name">NA</h2>
                ) : partnerDetails?.profilePic === undefined || null || " " ? (
                  <h2 className="profile-img-name">{getName(GetFName)}</h2>
                ) : (
                  <img
                    className="profile-pic"
                    src={partnerDetails?.profilePic}
                    alt="User Profile Icon"
                  />
                )}

              </div>
              <div className="profile__details__wrapper">
                <div className="user__details">
                  <div>
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <h3 className="user__details__name">
                        {GetFName}
                      </h3>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="user-profile__bottom row">
            <div className="col-12 col-md-6 contact">
              <p className="contact-number contact__details">
                <span className="icon-phone-icon"> </span>
                
                {loader ? (
                  <SmallLoader />
                ) :
                  partnerDetails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(partnerDetails?.mobile)
                  )}
              </p>

              <p className="email contact__details">
                <span className="icon-email">

                </span>
                {loader ? (
                  <SmallLoader />
                ) :
                  partnerDetails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(partnerDetails?.email)
                  )}

              </p>
              <p className="location contact__details">
                <span className="icon-location"></span>

                {/* {Address1 + "," + Address2 + "," + State + "," + City + "," + Zip} */}
                {loader ? (
                  <SmallLoader />
                ) : (
                  // </div>
                  addressArray([Address1, Address2, State, City, Zip])
                )}

              </p>

              <p className="code contact__details">
                <span className="icon-id-card"></span>
                {loader ? (
                  <SmallLoader />
                ) :
                  partnerDetails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(partnerDetails?.pan)
                  )}
              </p>
            </div>
            <div className="col-12 col-md-6 contact-right">
              <div className="contact-right__top d-flex align-items-end">
                <div className="referred-by">
                  <p className="bank-title">
                    Bank Details
                  </p>
                </div>
              </div>
              <ul className="contact-right__bottom">
                <li className="referrence-details">
                  <p className="bank-label">Bank Name</p>
                  <p className="bank-value">
                    {loader ? (
                      <SmallLoader />
                    ) :
                      partnerDetails === undefined || null || "" ? (
                        "NA"
                      ) : (
                        checkString(partnerDetails?.bankName)
                      )}
                  </p>

                </li>

                <li className="referrence-details">
                  <p className="bank-label"> Account Number</p>
                  <p className="bank-value">
                    {loader ? (
                      <SmallLoader />
                    ) :
                      partnerDetails === undefined || null || "" ? (
                        "NA"
                      ) : (
                        checkString(partnerDetails?.bankAcNumber)
                      )}
                  </p>
                </li>

                <li className="referrence-details">
                  <p className="bank-label"> IFSC Code</p>
                  <p className="bank-value">
                    {loader ? (

                      <SmallLoader />
                    ) :
                      partnerDetails === undefined || null ? (
                        "NA"
                      ) : (
                        checkString(partnerDetails?.ifscCode?.toUpperCase())
                      )}
                  </p>
                </li>

                <li className="referrence-details">
                  <p className="bank-label">  Branch Name</p>
                  <p className="bank-value">
                    {loader ? (

                      <SmallLoader />
                    ) :
                      partnerDetails === undefined || null ? (
                        "NA"
                      ) : (
                        checkString(partnerDetails?.branchName)
                      )}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* )} */}
      </div>
    </>
  );
}

export default PartnerApplicationStatusComp;
